var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_vm._m(0),_c('p',[(!_vm.$auth.isAuthenticated)?_c('button',{staticClass:"waves-effect waves-light btn-large orange accent-4",on:{"click":_vm.$auth.loginWithRedirect}},[_c('i',{staticClass:"fab fa-slack-hash"}),_vm._v("  Log in with Fool.com ")]):_vm._e()]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',[_c('strong',[_vm._v("Login")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('p',[_vm._v("Please click the Slack button above to log in")])])
}]

export { render, staticRenderFns }